import { Offer } from 'src/app/stores/stores';

export default class OfferUtils {
  static showPlusButton(offer: Offer, basketEnabled: boolean, orderingEnabled: boolean): boolean {
    const hasLongDescription = !!offer.longDescription;
    const hasOptions = offer.options?.length > 0;
    const isExpandable = offer.isExpandable;
    const isOrderable = offer.isOrderable;

    return hasLongDescription || hasOptions || isExpandable || (isOrderable && (basketEnabled || orderingEnabled));
  }
}
